export default (state = {}) => state
